import { AgGrid, Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import {
  billingLoadingCellRendererContainer,
  billingLoadingCellRendererText,
  billingSkeletonCellContainer,
  billingSkeletonEffect,
} from "./styles_vanilla.css";

export const LoadingCellRenderer = (props: AgGrid.ICellRendererParams) => {
  if (props.node.failedLoad) {
    return (
      <Flex
        className={billingLoadingCellRendererContainer}
        gap={Sizes.SM}
        data-testid="loading-error-container"
      >
        <Icon type="xmark" variant="solid" color={Colors.Danger600} />
        <Text className={billingLoadingCellRendererText}>Data failed to load</Text>
      </Flex>
    );
  }
  return (
    <Flex
      alignItems="center"
      className={billingSkeletonCellContainer}
      data-testid="loading-skeleton-cell"
    >
      <div className={billingSkeletonEffect} />
    </Flex>
  );
};
